(function ($) {
  "use strict";

  jQuery(document).ready(function () {
    console.log("ready to use bbb-custom-js !");
    /* file code start here */       
    
    var men_trouser_data = false;
    
    if(typeof KiwiSizing.data !== "undefined" && KiwiSizing.data.product > 0) {
      if(KiwiSizing.data.collections.length > 0) {
        var colls = KiwiSizing.data.collections;
        var product_collections = colls.split(',');
        men_trouser_data = true;
      }
    }
       

    //if(KiwiSizing.data.product == 7707479015672) { 
    //if(window.GloboPreorderParams.collectionId == 269843988672) {
    if(men_trouser_data) {
          var product_tags = KiwiSizing.data.tags.split(',');
          //var fit_arr = ['SLIM FIT']; 
          var fit_arr = ['BOOTCUT','COMFORT','REGULAR FIT','SKINNY FIT','SLIM FIT','SMART','STRAIGHT FIT','SUPER SKINNY FIT','TAPERED FIT','TAILORED FIT', 'LOOSE FIT']; 
      
          var fit_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], fit_arr) !== -1) {        
                  fit_tag_data.push(product_tags[i].toLowerCase());
                  console.log(fit_tag_data);
              }
          }
          if(fit_tag_data != "") {
              var fit_row_html = '<div class="index-row">';
                  fit_row_html += '<div class="index-rowKey">Fit</div>';
                  fit_row_html += '<div class="index-rowValue c-tag-title c-tag-title">'+fit_tag_data+'</div>';
                  fit_row_html += '</div>';
                  //console.log(fit_row_html);
              jQuery('#cus-tabel-desgin-html').append(fit_row_html);
          }
            var fabric_arr = [
              "ACRYLIC",
              "VISCOSE RAYON",
              "ORGANIC COTTON",
              "POLYVISCOSE",
              "OTHER",
              "ACRYLIC BLEND",
              "BLENDED",
              "COTTON",
              "COTTON BLEND",
              "LINEN",
              "LYOCELL",
              "MODAL",
              "NYLON",
              "POLYCOTTON",
              "POLYESTER",
              "POLYURETHANE",
              "VISCOSE",
              "WOOL",
              "WOOL BLEND",
              "ELASTANE"
          ];
          
          var fabric_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], fabric_arr) !== -1) {        
                  fabric_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(fabric_tag_data);
              }
          }
          if(fabric_tag_data != "") {
              var fabric_row_html = '<div class="index-row">';
              fabric_row_html += '<div class="index-rowKey">Fabric</div>';
              fabric_row_html += '<div class="index-rowValue c-tag-title">'+fabric_tag_data+'</div>';
              fabric_row_html += '</div>';
              //console.log(fabric_row_html);
              jQuery('#cus-tabel-desgin-html').append(fabric_row_html);
          }
        
        
          var pattern_arr = [
            "ABSTRACT",
            "CHECKED",
            "COLORBLOCKED",
            "Colourblocked",
            "PRINTED",
            "POLKA DOTS",
            "TEXTURED",
            "SOLID",
            "Solid",
            "Printed",
            "CONVERSATIONAL",
            "Striped",
            "STRIPED",
            "GEOMETRIC"
        ];
        
        var pattern_tag_data = [];
        for(var i = 0; i < product_tags.length;i++) {
            if(jQuery.inArray(product_tags[i], pattern_arr) !== -1) {        
                pattern_tag_data.push(product_tags[i].toLowerCase());
                //console.log(pattern_tag_data);
            }
        }
        if(pattern_tag_data != "") {
            var pattern_row_html = '<div class="index-row">';
                pattern_row_html += '<div class="index-rowKey">Print or Pattern Type</div>';
                pattern_row_html += '<div class="index-rowValue c-tag-title">'+pattern_tag_data+'</div>';
                pattern_row_html += '</div>';
                //console.log(pattern_row_html);
            jQuery('#cus-tabel-desgin-html').append(pattern_row_html);
        }
        
        
          var neck_arr = [
              "HENLEY",
              "HIGH",
              "HOODED",
              "MANDARIN",
              "MOCK",
              "NOTCHED LAPEL",
              "POLO",
              "ROUND",
              "SCOOP",
              "SPREAD",
              "V-NECK",
              "SHOULDER STRAPS",
              "ROUND NECK",
              "ONE SHOULDER"
          ];
          
          var neck_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], neck_arr) !== -1) {        
                  neck_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(neck_tag_data);
              }
          }
          if(neck_tag_data != "") {
              var neck_row_html = '<div class="index-row">';
                  neck_row_html += '<div class="index-rowKey">Neck</div>';
                  neck_row_html += '<div class="index-rowValue c-tag-title">'+neck_tag_data+'</div>';
                  neck_row_html += '</div>';
                  //console.log(neck_row_html);
              jQuery('#cus-tabel-desgin-html').append(neck_row_html);
          }
        
          var filteration_arr = [
              "UNVALVED",
              "VALVED"
          ];  
          var filteration_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], filteration_arr) !== -1) {        
                  filteration_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(filteration_tag_data);
              }
          }
          if(filteration_tag_data != "") {
              var filteration_row_html = '<div class="index-row">';
                  filteration_row_html += '<div class="index-rowKey">Filteration</div>';
                  filteration_row_html += '<div class="index-rowValue c-tag-title">'+filteration_tag_data+'</div>';
                  filteration_row_html += '</div>';
                  //console.log(filteration_row_html);
              jQuery('#cus-tabel-desgin-html').append(filteration_row_html);
          }
        
        
          var sleeves_arr = [
              "SLEEVELESS",
              "SHORT",
              "THREE-QUARTER",
              "LONG"
          ];
          var product_tags = KiwiSizing.data.tags.split(',');
          var sleeves_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], sleeves_arr) !== -1) {        
                  sleeves_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(sleeves_tag_data);
              }
          }
          if(sleeves_tag_data != "") {
              var sleeves_row_html = '<div class="index-row">';
              sleeves_row_html += '<div class="index-rowKey">Sleeves</div>';
              sleeves_row_html += '<div class="index-rowValue c-tag-title">'+sleeves_tag_data+'</div>';
              sleeves_row_html += '</div>';
              //console.log(sleeves_row_html);
              jQuery('#cus-tabel-desgin-html').append(sleeves_row_html);
          }
        
          var length_arr = [
            "ABOVE KNEE",
            "ANKLE",
            "Crop",
            "CROP",
            "Maxi",
            "MIDI",
            "LONGLINE",
            "KNEE LENGTH",
            "ANKLE LENGTH",
            "BELOW KNEE",
            "CROPPED",
            "FULL LENGTH",
            "HIP",
            "KNEE",
            "REGULAR",
            "THIGH",
            "WAIST"
        ];
        
        var length_tag_data = [];
        for(var i = 0; i < product_tags.length;i++) {
            if(jQuery.inArray(product_tags[i], length_arr) !== -1) {        
                length_tag_data.push(product_tags[i].toLowerCase());
                //console.log(length_tag_data);
            }
        }
        if(length_tag_data != "") {
            var length_row_html = '<div class="index-row">';
                length_row_html += '<div class="index-rowKey">Length</div>';
                length_row_html += '<div class="index-rowValue c-tag-title">'+length_tag_data+'</div>';
                length_row_html += '</div>';
                //console.log(length_row_html);
            jQuery('#cus-tabel-desgin-html').append(length_row_html);
        }
        
        
          var ptype_arr = [
              "Boys Blazer",
              "Boys Boxers",
              "Boys Jacket",
              "Boys Jeans",
              "Boys joggers",
              "Boys Kurta",
              "Boys Shirts",
              "Boys Shorts",
              "Boys Sweaters",
              "Boys Sweatshirts",
              "Boys T-Shirts",
              "Boys Track Pants",
              "Boys Trousers",
              "Girls Capris",
              "Girls Dress",
              "Girls Dungarees",
              "Girls Jackets",
              "Girls Jeans",
              "Girls Jumpsuit",
              "Girls Shirts",
              "Girls Shorts",
              "Girls Skirts",
              "Girls Sweaters",
              "Girls Sweatshirts",
              "Girls T-Shirts",
              "Girls Tops",
              "Girls Track Pants",
              "Kids Mask",
              "Mask",
              "Men Belt",
              "Men Blazer",
              "Men Blazers",
              "Men Boxers",
              "Men Denims",
              "Men Jacket",
              "Men Jeans",
              "Men Joggers",
              "Men Kurtas",
              "Men Lounge Pants",
              "Men Lounge Shorts",
              "Men Shackets",
              "Men Shirts",
              "Men Shorts",
              "Men Suits",
              "Men Sweat Shirts",
              "Men Sweaters",
              "Men Sweatshirts",
              "Men T-Shirts",
              "Men Track Pants",
              "Men Trousers",
              "Men Waist Coat",
              "Mens Jacket",
              "Shirts & Tops",
              "Women Belt",
              "Women Blazer",
              "Women Co-ord Sets",
              "Women Dresses",
              "Women Dungarees",
              "Women Jacket",
              "Women Jackets",
              "Women Jeans",
              "Women Joggers",
              "Women Jumpsuits",
              "Women Kurtas",
              "Women Lounge Pants",
              "Women Lounge Tops",
              "Women Night Suits",
              "Women Shirt",
              "Women Shirts",
              "Women Shorts",
              "Women Skirts",
              "Women Sweat Shirts",
              "Women Sweaters",
              "Women Sweatshirts",
              "Women T-Shirt",
              "Women T-Shirts",
              "Women Tank Top",
              "Women Tights",
              "Women Top",
              "Women Tops",
              "Women Track Pants",
              "Women Trouser",
              "Women Trousers",
              "Women Tunics"
          ];
          var product_type = KiwiSizing.data.type.split(',');
          var type_tag_data = [];
          for(var i = 0; i < product_type.length;i++) {
              if(jQuery.inArray(product_type[i], ptype_arr) !== -1) {        
                  type_tag_data.push(product_type[i].toLowerCase());
                  //console.log(type_tag_data);
              }
          } 
          if(type_tag_data != "") {
              var type_row_html = '<div class="index-row">';
              type_row_html += '<div class="index-rowKey">Product Type</div>';
              type_row_html += '<div class="index-rowValue c-tag-title">'+type_tag_data+'</div>';
              type_row_html += '</div>';
              //console.log(type_row_html);
              //jQuery('#cus-tabel-desgin-html').append(type_row_html);
          }


      var type_arr = [
            "BOMBER",
            "PENCIL",
            "REGULAR TROUSERS",
            "BOOTCUT TROUSERS",
            "REGULAR SHORTS",
            "FITTED",            
            "BOLERO JACKET",
            "PARALLEL TROUSERS"
        ];
        var product_type = KiwiSizing.data.type.split(',');
        var type_tag_data = [];
        for(var i = 0; i < product_type.length;i++) {
            if(jQuery.inArray(product_type[i], type_arr) !== -1) {        
                type_tag_data.push(product_type[i].toLowerCase());
                //console.log(type_tag_data);
            }
        } 
        if(type_tag_data != "") {
            var type_row_html = '<div class="index-row">';
            type_row_html += '<div class="index-rowKey">Type</div>';
            type_row_html += '<div class="index-rowValue c-tag-title">'+type_tag_data+'</div>';
            type_row_html += '</div>';
            //console.log(type_row_html);
            jQuery('#cus-tabel-desgin-html').append(type_row_html);
        }

        // Waist Rise
        var Waist_Rise_arr = [
              "MID-RISE",
              "HIGH-RISE"
          ];
          var product_type = KiwiSizing.data.type.split(',');
          var Waist_Rise_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], Waist_Rise_arr) !== -1) {        
                  Waist_Rise_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(Waist_Rise_tag_data);
              }
          } 
          if(Waist_Rise_tag_data != "") {
              var Waist_Rise_row_html = '<div class="index-row">';
              Waist_Rise_row_html += '<div class="index-rowKey">Waist Rise</div>';
              Waist_Rise_row_html += '<div class="index-rowValue c-tag-title">'+Waist_Rise_tag_data+'</div>';
              Waist_Rise_row_html += '</div>';
              //console.log(Waist_Rise_row_html);
              jQuery('#cus-tabel-desgin-html').append(Waist_Rise_row_html);
          }

        // fly type
        var product_tags = KiwiSizing.data.tags.split(',');
        var Fly_Type_arr = [
              "ZIP",
              "NO FLY" 
          ];  
          var Fly_Type_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], Fly_Type_arr) !== -1) {        
                  Fly_Type_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(Fly_Type_tag_data);
              }
          } 
          if(Fly_Type_tag_data != "") {
              var Fly_Type_row_html = '<div class="index-row">';
              Fly_Type_row_html += '<div class="index-rowKey">Fly Type</div>';
              Fly_Type_row_html += '<div class="index-rowValue c-tag-title">'+Fly_Type_tag_data+'</div>';
              Fly_Type_row_html += '</div>';
              //console.log(Fly_Type_row_html);
              jQuery('#cus-tabel-desgin-html').append(Fly_Type_row_html);
          }

        // Brand_Fit_Name
        var product_tags = KiwiSizing.data.tags.split(',');
        var Brand_Fit_Name_arr = [
              "Urban",
              "STANDARD",
              "JHODPURI",
              "URBAN",
              "RELAXED STRAIGHT LEG"
        ];  
          var Brand_Fit_Name_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], Brand_Fit_Name_arr) !== -1) {        
                  Brand_Fit_Name_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(Brand_Fit_Name_tag_data);
              }
          } 
          if(Brand_Fit_Name_tag_data != "") {
              var Brand_Fit_Name_row_html = '<div class="index-row">';
              Brand_Fit_Name_row_html += '<div class="index-rowKey">Brand Fit Name</div>';
              Brand_Fit_Name_row_html += '<div class="index-rowValue c-tag-title">'+Brand_Fit_Name_tag_data+'</div>';
              Brand_Fit_Name_row_html += '</div>';
              //console.log(Brand_Fit_Name_row_html);
              jQuery('#cus-tabel-desgin-html').append(Brand_Fit_Name_row_html);
          }


        // closure
        var product_tags = KiwiSizing.data.tags.split(',');
        var closure_arr = [
              "button",
              "BUTTON",
              "ZIP",
              "FRONT-OPEN"
          ];  
          var closure_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], closure_arr) !== -1) {        
                  closure_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(closure_tag_data);
              }
          } 
          if(closure_tag_data != "") {
              var closure_row_html = '<div class="index-row">';
              closure_row_html += '<div class="index-rowKey">Closure</div>';
              closure_row_html += '<div class="index-rowValue c-tag-title">'+closure_tag_data+'</div>';
              closure_row_html += '</div>';
              //console.log(closure_row_html);
              jQuery('#cus-tabel-desgin-html').append(closure_row_html);
          }
        //
        var product_tags = KiwiSizing.data.tags.split(',');
        var type_of_pleat_arr = [
              "FLAT-FRONT",
              "PLEATED"
          ];  
          var type_of_pleat_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], type_of_pleat_arr) !== -1) {        
                  type_of_pleat_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(type_of_pleat_tag_data);
              }
          } 
          if(type_of_pleat_tag_data != "") {
              var type_of_pleat_row_html = '<div class="index-row">';
              type_of_pleat_row_html += '<div class="index-rowKey">Type of Pleat</div>';
              type_of_pleat_row_html += '<div class="index-rowValue c-tag-title">'+type_of_pleat_tag_data+'</div>';
              type_of_pleat_row_html += '</div>';
              //console.log(type_of_pleat_row_html);
              jQuery('#cus-tabel-desgin-html').append(type_of_pleat_row_html);
          }

        //
        var product_tags = KiwiSizing.data.tags.split(',');
        var weave_type_arr = [
              "WOVEN"
          ];  
          var weave_type_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], weave_type_arr) !== -1) {        
                  weave_type_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(weave_type_tag_data);
              }
          } 
          if(weave_type_tag_data != "") {
              var weave_type_row_html = '<div class="index-row">';
              weave_type_row_html += '<div class="index-rowKey">Weave Type</div>';
              weave_type_row_html += '<div class="index-rowValue c-tag-title">'+weave_type_tag_data+'</div>';
              weave_type_row_html += '</div>';
              //console.log(weave_type_row_html);
              jQuery('#cus-tabel-desgin-html').append(weave_type_row_html);
          }

        //
        var product_tags = KiwiSizing.data.tags.split(',');
        var number_of_pockets_arr = [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
          ];  
      
          var number_of_pockets_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], number_of_pockets_arr) !== -1) {        
                  number_of_pockets_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(number_of_pockets_tag_data);
              }
          } 
          if(number_of_pockets_tag_data != "") {
              var number_of_pockets_row_html = '<div class="index-row">';
              number_of_pockets_row_html += '<div class="index-rowKey">Number Of Pockets</div>';
              number_of_pockets_row_html += '<div class="index-rowValue c-tag-title">'+number_of_pockets_tag_data+'</div>';
              number_of_pockets_row_html += '</div>';
              //console.log(number_of_pockets_row_html);
              jQuery('#cus-tabel-desgin-html').append(number_of_pockets_row_html);
          }

        var product_tags = KiwiSizing.data.tags.split(',');
        var features_arr = [
              "PLAIN",
              "LIGHTWEIGHT",
              "TRAVEL FEATURES",
              "EASY WASH",
          ];  
          var features_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], features_arr) !== -1) {        
                  features_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(features_tag_data);
              }
          } 
          if(features_tag_data != "") {
              var features_row_html = '<div class="index-row">';
              features_row_html += '<div class="index-rowKey">Features</div>';
              features_row_html += '<div class="index-rowValue c-tag-title">'+features_tag_data+'</div>';
              features_row_html += '</div>';
              //console.log(features_row_html);
              jQuery('#cus-tabel-desgin-html').append(features_row_html);
          }

    //
        var product_tags = KiwiSizing.data.tags.split(',');
        var main_trend_arr = [
              "NEW BASICS"      
          ];  
          var main_trend_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], main_trend_arr) !== -1) {        
                  main_trend_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(main_trend_tag_data);
              }
          } 
          if(main_trend_tag_data != "") {
              var main_trend_row_html = '<div class="index-row">';
              main_trend_row_html += '<div class="index-rowKey">Main Trend</div>';
              main_trend_row_html += '<div class="index-rowValue c-tag-title">'+main_trend_tag_data+'</div>';
              main_trend_row_html += '</div>';
              //console.log(main_trend_row_html);
              jQuery('#cus-tabel-desgin-html').append(main_trend_row_html);
          }

        // 
        var product_tags = KiwiSizing.data.tags.split(',');
        var occasion_arr = [
              "casual",
              "Semiformal",
              "Party",
              "CASUAL",
              "SEMIFORMAL",
              "PARTY"
          ];  
          var occasion_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], occasion_arr) !== -1) {        
                  occasion_tag_data.push(product_tags[i].toLowerCase());
                  //console.log(occasion_tag_data);
              }
          } 
          if(occasion_tag_data != "") {
              var occasion_row_html = '<div class="index-row">';
              occasion_row_html += '<div class="index-rowKey">Occasion</div>';
              occasion_row_html += '<div class="index-rowValue c-tag-title">'+occasion_tag_data+'</div>';
              occasion_row_html += '</div>';
              //console.log(occasion_row_html);
              jQuery('#cus-tabel-desgin-html').append(occasion_row_html);
          }

      //
      var product_tags = KiwiSizing.data.tags.split(',');
      var collar_arr = ["Club Collar","MANDARIN","Mandarin Collar","Mock Collar","NOTCHED LAPEL","Spread Collar","STAND COLLAR","Stand Collar"];
      
          var collar_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], collar_arr) !== -1) {        
                  collar_tag_data.push(product_tags[i].toLowerCase());
                  console.log(collar_tag_data);
              }
          } 
      
          if(collar_tag_data != "") {
            console.log('collar not empty '+collar_tag_data);
              var collar_row_html = '<div class="index-row">';
              collar_row_html += '<div class="index-rowKey">Collar</div>';
              collar_row_html += '<div class="index-rowValue c-tag-title">'+collar_tag_data+'</div>';
              collar_row_html += '</div>';
              //console.log(collar_row_html);
              jQuery('#cus-tabel-desgin-html').append(collar_row_html);
          }

        // Surface Styling
        var Surface_Styling_arr = [
          "STUDDED",
          "ZIP DETAIL",
          "TIE-UPS",
          "CUT-OUTS",
          "SIDE TAPE",
          "OTHER",
          "SHOULDER TABS",
          "BOX POCKETS"
        ];
      
          var Surface_Styling_tag_data = [];
          for(var i = 0; i < product_tags.length;i++) {
              if(jQuery.inArray(product_tags[i], Surface_Styling_arr) !== -1) {        
                  Surface_Styling_tag_data.push(product_tags[i].toLowerCase());
                  console.log(Surface_Styling_tag_data);
              }
          } 
      
          if(Surface_Styling_tag_data != "") {            
              var Surface_Styling_row_html = '<div class="index-row">';
              Surface_Styling_row_html += '<div class="index-rowKey">Surface Styling</div>';
              Surface_Styling_row_html += '<div class="index-rowValue c-tag-title">'+Surface_Styling_tag_data+'</div>';
              Surface_Styling_row_html += '</div>';
              //console.log(Surface_Styling_row_html);
              jQuery('#cus-tabel-desgin-html').append(Surface_Styling_row_html);
          }


          // Lining Fabric lining_fabric
            var lining_fabric_arr = [
              "UNLINED"
            ];
          
              var lining_fabric_tag_data = [];
              for(var i = 0; i < product_tags.length;i++) {
                  if(jQuery.inArray(product_tags[i], lining_fabric_arr) !== -1) {        
                      lining_fabric_tag_data.push(product_tags[i].toLowerCase());
                      console.log(lining_fabric_tag_data);
                  }
              } 
          
              if(lining_fabric_tag_data != "") {            
                  var lining_fabric_row_html = '<div class="index-row">';
                  lining_fabric_row_html += '<div class="index-rowKey">Lining Fabric</div>';
                  lining_fabric_row_html += '<div class="index-rowValue c-tag-title">'+lining_fabric_tag_data+'</div>';
                  lining_fabric_row_html += '</div>';
                  //console.log(lining_fabric_row_html);
                  jQuery('#cus-tabel-desgin-html').append(lining_fabric_row_html);
              }

            // Wash Care wash_care
            var wash_care_arr = [
              "DRY CLEAN",
              "HAND WASH"
            ];
          
              var wash_care_tag_data = [];
              for(var i = 0; i < product_tags.length;i++) {
                  if(jQuery.inArray(product_tags[i], wash_care_arr) !== -1) {        
                      wash_care_tag_data.push(product_tags[i].toLowerCase());
                      console.log(wash_care_tag_data);
                  }
              } 
          
              if(wash_care_tag_data != "") {            
                  var wash_care_row_html = '<div class="index-row">';
                  wash_care_row_html += '<div class="index-rowKey">Wash Care</div>';
                  wash_care_row_html += '<div class="index-rowValue c-tag-title">'+wash_care_tag_data+'</div>';
                  wash_care_row_html += '</div>';
                  //console.log(wash_care_row_html);
                  jQuery('#cus-tabel-desgin-html').append(wash_care_row_html);
              }

              // Hemline
              var hemline_arr = [
                "STRAIGHT",
                "CURVED"
              ];
            
                var hemline_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], hemline_arr) !== -1) {        
                        hemline_tag_data.push(product_tags[i].toLowerCase());
                        console.log(hemline_tag_data);
                    }
                } 
            
                if(hemline_tag_data != "") {
                    var hemline_row_html = '<div class="index-row">';
                    hemline_row_html += '<div class="index-rowKey">Hemline</div>';
                    hemline_row_html += '<div class="index-rowValue c-tag-title">'+hemline_tag_data+'</div>';
                    hemline_row_html += '</div>';
                    //console.log(hemline_row_html);
                    jQuery('#cus-tabel-desgin-html').append(hemline_row_html);
                }

              // Sport
              var sport_arr = [
                "OUTDOOR"
                  ];
            
                var sport_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], sport_arr) !== -1) {        
                        sport_tag_data.push(product_tags[i].toLowerCase());
                        console.log(sport_tag_data);
                    }
                } 
            
                if(sport_tag_data != "") {
                    var sport_row_html = '<div class="index-row">';
                    sport_row_html += '<div class="index-rowKey">Sport</div>';
                    sport_row_html += '<div class="index-rowValue c-tag-title">'+sport_tag_data+'</div>';
                    sport_row_html += '</div>';
                    //console.log(sport_row_html);
                    jQuery('#cus-tabel-desgin-html').append(sport_row_html);
                }

              // Sustainable sustainable
              var sustainable_arr = [
                "SUSTAINABLE"
                  ];
            
                var sustainable_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], sustainable_arr) !== -1) {        
                        sustainable_tag_data.push(product_tags[i].toLowerCase());
                        console.log(sustainable_tag_data);
                    }
                } 
            
                if(sustainable_tag_data != "") {
                    var sustainable_row_html = '<div class="index-row">';
                    sustainable_row_html += '<div class="index-rowKey">Sustainable</div>';
                    sustainable_row_html += '<div class="index-rowValue c-tag-title">'+sustainable_tag_data+'</div>';
                    sustainable_row_html += '</div>';
                    //console.log(sustainable_row_html);
                    jQuery('#cus-tabel-desgin-html').append(sustainable_row_html);
                }

                // Shape shape
                var shape_arr = [
                "WRAP",
                "GOWN"
                  ];
            
                var shape_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], shape_arr) !== -1) {        
                        shape_tag_data.push(product_tags[i].toLowerCase());
                        console.log(shape_tag_data);
                    }
                } 
            
                if(shape_tag_data != "") {
                    var shape_row_html = '<div class="index-row">';
                    shape_row_html += '<div class="index-rowKey">Shape</div>';
                    shape_row_html += '<div class="index-rowValue c-tag-title">'+shape_tag_data+'</div>';
                    shape_row_html += '</div>';
                    //console.log(shape_row_html);
                    jQuery('#cus-tabel-desgin-html').append(shape_row_html);
                }

              // Knit or Woven knit_woven
                var knit_woven_arr = [
                "WOVEN"
                  ];
            
                var knit_woven_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], knit_woven_arr) !== -1) {        
                        knit_woven_tag_data.push(product_tags[i].toLowerCase());
                        console.log(knit_woven_tag_data);
                    }
                } 
            
                if(knit_woven_tag_data != "") {
                    var knit_woven_row_html = '<div class="index-row">';
                    knit_woven_row_html += '<div class="index-rowKey">Knit or Woven</div>';
                    knit_woven_row_html += '<div class="index-rowValue c-tag-title">'+knit_woven_tag_data+'</div>';
                    knit_woven_row_html += '</div>';
                    //console.log(knit_woven_row_html);
                    jQuery('#cus-tabel-desgin-html').append(knit_woven_row_html);
                }

                // Sleeve Styling sleeve_styling
                var sleeve_styling_arr = [
                  "SHOULDER STRAPS",
                  "NO SLEEVES",
                  "ROLL-UP SLEEVES",
                  "REGULAR SLEEVES",
                  "CAP SLEEVES",
                  "COLD-SHOULDER SLEEVES",
                  "PUFF SLEEVES"
                  ];
            
                var sleeve_styling_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], sleeve_styling_arr) !== -1) {        
                        sleeve_styling_tag_data.push(product_tags[i].toLowerCase());
                        console.log(sleeve_styling_tag_data);
                    }
                } 
            
                if(sleeve_styling_tag_data != "") {
                    var sleeve_styling_row_html = '<div class="index-row">';
                    sleeve_styling_row_html += '<div class="index-rowKey">Sleeve Styling</div>';
                    sleeve_styling_row_html += '<div class="index-rowValue c-tag-title">'+sleeve_styling_tag_data+'</div>';
                    sleeve_styling_row_html += '</div>';
                    //console.log(sleeve_styling_row_html);
                    jQuery('#cus-tabel-desgin-html').append(sleeve_styling_row_html);
                }

                // Transparency transparency
                var transparency_arr = [
                "OPAQUE"
                  ];
            
                var transparency_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], transparency_arr) !== -1) {        
                        transparency_tag_data.push(product_tags[i].toLowerCase());
                        console.log(transparency_tag_data);
                    }
                } 
            
                if(transparency_tag_data != "") {
                    var transparency_row_html = '<div class="index-row">';
                    transparency_row_html += '<div class="index-rowKey">Transparency</div>';
                    transparency_row_html += '<div class="index-rowValue c-tag-title">'+transparency_tag_data+'</div>';
                    transparency_row_html += '</div>';
                    //console.log(transparency_row_html);
                    jQuery('#cus-tabel-desgin-html').append(transparency_row_html);
                }

                // Sub Trend sub_trend
                var sub_trend_arr = [
                "GEOMETRIC PRINT"
                  ];
            
                var sub_trend_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], sub_trend_arr) !== -1) {        
                        sub_trend_tag_data.push(product_tags[i].toLowerCase());
                        console.log(sub_trend_tag_data);
                    }
                } 
            
                if(sub_trend_tag_data != "") {
                    var sub_trend_row_html = '<div class="index-row">';
                    sub_trend_row_html += '<div class="index-rowKey">Sub Trend</div>';
                    sub_trend_row_html += '<div class="index-rowValue c-tag-title">'+sub_trend_tag_data+'</div>';
                    sub_trend_row_html += '</div>';
                    //console.log(sub_trend_row_html);
                    jQuery('#cus-tabel-desgin-html').append(sub_trend_row_html);
                }

                // Slit Detail slit_detail
                var slit_detail_arr = [
                "SIDE SLIT"
                  ];
            
                var slit_detail_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], slit_detail_arr) !== -1) {        
                        slit_detail_tag_data.push(product_tags[i].toLowerCase());
                        console.log(slit_detail_tag_data);
                    }
                } 
            
                if(slit_detail_tag_data != "") {
                    var slit_detail_row_html = '<div class="index-row">';
                    slit_detail_row_html += '<div class="index-rowKey">Slit Detail</div>';
                    slit_detail_row_html += '<div class="index-rowValue c-tag-title">'+slit_detail_tag_data+'</div>';
                    slit_detail_row_html += '</div>';
                    //console.log(slit_detail_row_html);
                    jQuery('#cus-tabel-desgin-html').append(slit_detail_row_html);
                }

                // Weave Pattern weave_pattern
                var weave_pattern_arr = [
                  "TWILL"
                  ];
            
                var weave_pattern_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], weave_pattern_arr) !== -1) {        
                        weave_pattern_tag_data.push(product_tags[i].toLowerCase());
                        console.log(weave_pattern_tag_data);
                    }
                } 
            
                if(weave_pattern_tag_data != "") {
                    var weave_pattern_row_html = '<div class="index-row">';
                    weave_pattern_row_html += '<div class="index-rowKey">Weave Pattern</div>';
                    weave_pattern_row_html += '<div class="index-rowValue c-tag-title">'+weave_pattern_tag_data+'</div>';
                    weave_pattern_row_html += '</div>';
                    //console.log(weave_pattern_row_html);
                    jQuery('#cus-tabel-desgin-html').append(weave_pattern_row_html);
                }

                // placket placket
                var placket_arr = [
                  "CONCEALED BUTTON PLACKET",
                  "BUTTON PLACKET",
                  "ZIP"
                  ];
            
                var placket_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], placket_arr) !== -1) {        
                        placket_tag_data.push(product_tags[i].toLowerCase());
                        console.log(placket_tag_data);
                    }
                } 
            
                if(placket_tag_data != "") {
                    var placket_row_html = '<div class="index-row">';
                    placket_row_html += '<div class="index-rowKey">Placket</div>';
                    placket_row_html += '<div class="index-rowValue c-tag-title">'+placket_tag_data+'</div>';
                    placket_row_html += '</div>';
                    //console.log(placket_row_html);
                    jQuery('#cus-tabel-desgin-html').append(placket_row_html);
                }

                // Placket Length placket_length
                var placket_length_arr = [
                  "FULL"
                  ];
            
                var placket_length_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], placket_length_arr) !== -1) {        
                        placket_length_tag_data.push(product_tags[i].toLowerCase());
                        console.log(placket_length_tag_data);
                    }
                } 
            
                if(placket_length_tag_data != "") {
                    var placket_length_row_html = '<div class="index-row">';
                    placket_length_row_html += '<div class="index-rowKey">Placket Length</div>';
                    placket_length_row_html += '<div class="index-rowValue c-tag-title">'+placket_length_tag_data+'</div>';
                    placket_length_row_html += '</div>';
                    //console.log(placket_length_row_html);
                    jQuery('#cus-tabel-desgin-html').append(placket_length_row_html);
                }

                // Cuff cuff
                var cuff_arr = [
                    "BUTTON",
                    "NO CUFF"
                    ];
                
                var cuff_tag_data = [];
                for(var i = 0; i < product_tags.length;i++) {
                    if(jQuery.inArray(product_tags[i], cuff_arr) !== -1) {        
                        cuff_tag_data.push(product_tags[i].toLowerCase());
                        console.log(cuff_tag_data);
                    }
                } 
                
                if(cuff_tag_data != "") {
                    var cuff_row_html = '<div class="index-row">';
                    cuff_row_html += '<div class="index-rowKey">Cuff</div>';
                    cuff_row_html += '<div class="index-rowValue c-tag-title">'+cuff_tag_data+'</div>';
                    cuff_row_html += '</div>';
                    //console.log(cuff_row_html);
                    jQuery('#cus-tabel-desgin-html').append(cuff_row_html);
                }

      // add_ons 
        var add_ons_arr = [
            "COMES WITH A BELT"
            ];
        
        var add_ons_tag_data = [];
        for(var i = 0; i < product_tags.length;i++) {
            if(jQuery.inArray(product_tags[i], add_ons_arr) !== -1) {        
                add_ons_tag_data.push(product_tags[i].toLowerCase());
                console.log(add_ons_tag_data);
            }
        } 
        
        if(add_ons_tag_data != "") {
            var add_ons_row_html = '<div class="index-row">';
            add_ons_row_html += '<div class="index-rowKey">Add Ons</div>';
            add_ons_row_html += '<div class="index-rowValue c-tag-title">'+add_ons_tag_data+'</div>';
            add_ons_row_html += '</div>';
            //console.log(add_ons_row_html);
            jQuery('#cus-tabel-desgin-html').append(add_ons_row_html);
        }

      // front_styling
      var front_styling_arr = [
          "OPEN FRONT",
          "SINGLE-BREASTED",
          "TUXEDO"
          ];
      
      var front_styling_tag_data = [];
      for(var i = 0; i < product_tags.length;i++) {
          if(jQuery.inArray(product_tags[i], front_styling_arr) !== -1) {        
              front_styling_tag_data.push(product_tags[i].toLowerCase());
              console.log(front_styling_tag_data);
          }
      } 
      
      if(front_styling_tag_data != "") {
          var front_styling_row_html = '<div class="index-row">';
          front_styling_row_html += '<div class="index-rowKey">Front Styling</div>';
          front_styling_row_html += '<div class="index-rowValue c-tag-title">'+front_styling_tag_data+'</div>';
          front_styling_row_html += '</div>';
          //console.log(front_styling_row_html);
          jQuery('#cus-tabel-desgin-html').append(front_styling_row_html);
      }
      

        
    }
    if(jQuery('.c-tag-title').length > 0) {
      jQuery('.product-speci').show();
    } else {
      jQuery('.product-speci').hide();
    }

    /*setTimeout(function(){
      var index_counter = 1;
        if(jQuery(".gf-filter-contents-inner .gf-option-block").length > 10) {
            var filter_length = jQuery(".gf-filter-contents-inner .gf-option-block").length;
            jQuery('.gf-filter-contents-inner .gf-option-block').each(function(index,value) {
                console.log(index_counter);
                if(index_counter == 10) {
                    console.log(index_counter);
                    var view_more_html = '<div id="view-more-filter-sec-id" data-filter-type="Tag" data-filter-id="" class="gf-option-block gf-option-block-checkbox none is-collapsed">';
                    view_more_html += '<div class="gf-block-title">';
                    view_more_html += '<a id="filter-view-more-btn" href="javascript:void(0)">+'+parseInt(filter_length-10)+' More </a>';
                    view_more_html += '</div>';
                    view_more_html += '</div>';
                    jQuery(".gf-filter-contents-inner .gf-option-block:nth-child(10)").after(view_more_html);
                } else if(index > 9){
                    jQuery(this).hide();
                    //console.log(index_counter);
                }
                index_counter++;
            });    
        }

        jQuery('#filter-view-more-btn').click(function() {
            jQuery(".gf-filter-contents-inner .gf-option-block").show();
            //jQuery(this).closest('div').remove();
            jQuery('#view-more-filter-sec-id').remove()
        });
       }, 2000);  */
    

    

    
    
    

  /* file code end here */
  });
})(jQuery);

